import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "./config";
import { LoginPage } from "./pages/LoginPage";
import { MagicVerifyPage } from "./pages/MagicVerifyPage";
import { GamesPage } from "./pages/GamesPage";
import { MembersPage } from "./pages/MembersPage";
import { TeamsPage } from "./pages/TeamsPage";
import { ClubsPage } from "./pages/ClubsPage";
import { SchedulesPage } from "./pages/SchedulesPage";
import { GameDetailPage } from "./pages/GameDetailPage";
import { AuthedLayout } from "./components/AuthedLayout";

export function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/magic" element={<MagicVerifyPage />} />
          {/* Layout route: one auth guard, one ClubProvider, one Header for
              every signed-in page. Keeping the provider above the individual
              routes is what lets the active club survive navigation. */}
          <Route element={<AuthedLayout />}>
            <Route path="/" element={<GamesPage />} />
            <Route path="/members" element={<MembersPage />} />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/clubs" element={<ClubsPage />} />
            <Route path="/schedules" element={<SchedulesPage />} />
            <Route path="/games/:gameId" element={<GameDetailPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}
